import { icons, Plugin } from '@ckeditor/ckeditor5-core';
import ButtonView from '@ckeditor/ckeditor5-ui/src/button/buttonview';
import '../styles.css';
export default class Imagesui extends Plugin {

    constructor(editor) {
        super(editor);
        this.editor = editor;
        this.getMediaURLCallback = null;
        this.modalInstance = null;
        this._mediaSelectedHandler = null;
    }

    browseModalInstanceController(imagesInstance, $scope, $uibModal, $modalInstance, editorId) {
        $scope.onModalCloseButtonClick = function () {
            let $uibModalInstance = null;
            if (angular.element(document.body).injector().has('$modal')) {
                $uibModalInstance = angular.element(document.body).injector().get('$modal');
            } else {
                $uibModalInstance = angular.element(document.body).injector().get('$uibModal');
            }
            $modalInstance.close();
        };

        $scope.onMediaClick = function () {
            $modalInstance.close();
        };
    }

    openImagePaletteModal(currentEditor) {
        const $uibModal = angular.element(document.body).injector().get('$uibModal');
        const $scope = angular.element(document.body).scope();
        const $signals = angular.element(document.body).injector().get('$signals');
        $scope.currentEditorId = currentEditor.id;
        $scope.currentAreaId = currentEditor.sourceElement.id;
        console.log('currentEditor ===>', currentEditor);

        this.modalInstance = $uibModal.open({
            templateUrl: '/views/ib/cms/eassessment/modal/eassessmentmediabrowserModalCk5.html',
            scope: $scope,
        });

        this.browseModalInstanceController(this, $scope, $uibModal, this.modalInstance);
    }

    init() {
        const editor = this.editor;
        const $signals = angular.element(document.body).injector().get('$signals');
        let currentEditor = null;

        editor.ui.componentFactory.add('imagePalette', () => {
            const button = new ButtonView();

            button.set({
                label: 'Images',
                withText: false,
                icon: icons.imageUpload,
                class: 'ck-search__reset',
                tooltip: true
            });

            this.listenTo(button, 'execute', () => {
                currentEditor = editor;
                this.openImagePaletteModal(currentEditor);
            });

            this._mediaSelectedHandler = (data, currentEditorId) => {
                if (editor.id === currentEditorId) {
                    // editor.execute( 'insertImage', { source: data } );
                    $signals.emit('mediaSelected_ck5', data, editor);
                }
                this.modalInstance && this.modalInstance.close();
            };
            $signals.on('mediaSelected', this._mediaSelectedHandler);

            return button;
        });
    }

    destroy() {
        if (this._mediaSelectedHandler) {
            const $signals = angular.element(document.body).injector().get('$signals');
            $signals.remove('mediaSelected', this._mediaSelectedHandler);
            this._mediaSelectedHandler = null;
        }
        super.destroy();
    }

    getMediaURL(selectedMedia) {
        return selectedMedia.url;
    }

    getSecureMediaURL(selectedMedia) {
        // Überprüfen, ob selectedMedia ein Media-Objekt ist
        if (selectedMedia instanceof Media) {
            return selectedMedia.getSecureURL();
        }

        // Wenn es kein Media-Objekt ist, versuchen wir, die notwendigen Informationen zu extrahieren
        const { id, hash1, hash2, filename } = selectedMedia;
        if (id && hash1 && hash2 && filename) {
            return `https://localhost/secure/${hash1}/${hash2}/${id}/${filename}`;
        }

        // Fallback: Wenn wir die sichere URL nicht erstellen können, geben wir die ursprüngliche URL zurück
        console.warn('Could not generate secure URL for media:', selectedMedia);
        return selectedMedia.url || '';
    }
}
